import { LibraryPanel } from "@data/regulationLibraryCatalog";

export const REGULATION_LIBRARY_OPEN_KEY = "regulation_library_open";

export interface RegulationLibraryDeepLink {
  facilitySlug: string;
  facilityLabel: string;
  facilityName: string;
  stateCode: string;
  panel: LibraryPanel;
  showBanner: boolean;
}

export function saveRegulationLibraryDeepLink(link: RegulationLibraryDeepLink): void {
  sessionStorage.setItem(REGULATION_LIBRARY_OPEN_KEY, JSON.stringify(link));
}

export function consumeRegulationLibraryDeepLink(): RegulationLibraryDeepLink | null {
  try {
    const raw = sessionStorage.getItem(REGULATION_LIBRARY_OPEN_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(REGULATION_LIBRARY_OPEN_KEY);
    const parsed = JSON.parse(raw) as RegulationLibraryDeepLink;
    if (!parsed || typeof parsed.facilitySlug !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}
